<template>
    <div v-if="graph == undefined || graph.datasets.length > 0">
        <h2> Tag Breakdown </h2>
        <vue-frappe
            id="tag-seven-day"
            type="bar"
            :key="graph.update"
            :labels="graph.labels"
            :height="300"
            :barOptions="{ stacked: 1 }"
            :tooltipOptions="{ formatTooltipX: d => (d + '').toUpperCase(), formatTooltipY: d => niceTime(d)}"
            :colors="['#8FBCBB', '#BF616A', '#D08770', '#EBCB8B', '#A3BE8C', '#B48EAD']"
            :dataSets="graph.datasets">
        </vue-frappe>
    </div>
</template>
<script>
import {niceTime} from "../util/format.js"
    export default {
        data () {
            return {
                task: null
            }
        },
        methods: {
            niceTime: niceTime
        },
        computed: {
            graph(){
                console.log(this.task.frappe(true))
                return this.task.frappe(true)
            }
        },
        watch: {
            id: {
                handler(){
                    this.task = this.$root.tasks.getChild(this.id)
                },
                immediate: true
            }
        },
        props: ["id"]
    }
</script>
